import { AxiosResponse } from 'axios';
import { UserResponse } from 'Models/User';
import { getAxiosInstance } from 'Utils/Http/ApiManager';
import { ApiUrl, getApiUrl } from 'Utils/Http/ApiUrls';

export interface GetUsersResponse {
	users: UserResponse[];
}

const getUsers = async (token: string | null): Promise<AxiosResponse<GetUsersResponse>> => {
	const url = getApiUrl(ApiUrl.Users);
	const axios = getAxiosInstance(token);
	return axios.get<GetUsersResponse>(url);
};

export default getUsers;
